import React, { Component} from 'react'
import { connect } from 'react-redux'
import { Badge, Button, Card, Dropdown, Modal, Pagination, Spinner } from 'react-bootstrap'
import Header from '../Header'
import 'react-toastify/dist/ReactToastify.css'
import '../Home/animation.css'
import { Row, Col } from 'react-bootstrap'
import { toast } from 'react-toastify'
import Skeleton from 'react-loading-skeleton'
import { urlapi, key_local_storage_cart, key_local_storage_user, url_images, pagina } from '../../lib/backend/data'
import { formatoMoneda, showAmmount } from '../../lib/helpers/helpers'
import Carrito from '../Header/carrito'
import { FaAngleDown } from 'react-icons/fa'
import { IoClose, IoCloseSharp } from 'react-icons/io5'
import { guardarInterfaz } from '../../redux/actions/interfaz'
import { IoIosStar } from "react-icons/io";
import CategoriasSelector from '../../subComponents/categorias/categorias_productos'
import { Alert, Chip, debounce, Dialog, Drawer, Snackbar, Tooltip } from '@mui/material'
import { cerrarSesion } from '../../redux/actions/session'
import { refrescarTienda } from '../../redux/actions/tienda'
import Banners from './banners'
import BoxListProduct from './boxListProduct'
import { FaCartShopping } from 'react-icons/fa6'
import MessageTop from './messageTop'
import NewletterSite from './newsletter'
import SocialIcons from './socialMedia'
import FooterText from './footerText'
import BuscadorProductoPublico from '../../subComponents/productos/buscador_producto_publico'
import withRouterV6 from '../General/router'
import { capitalizeFirstLetter } from '../../lib/helpers/main'
import UseCart from './use_cart'

class Home extends Component {
    constructor(){
        super()
        this.state = {
            username: '',
            password: '',
            submitted: false,
            loading: false,
            errorLogin: '',
            loadinguser: true,
            loadinginsignias: true,
            insignias: [],
            selec_marca: '',
            selec_modelo: '',
            loadingSite: true,
            condicion: { },
            selec_ano: '',
            selec_palabra: '',
            total: 0,
            pagina: 1,
            selec_cilindrada: '',
            resultados: [],
            loadingResultados: true,
            loadingModelos: true,
            showModalCarrito: false,
            category: "",
            loadingCilindrada: true,
            cilindradas: [],
            modelos: [],
            carrito: localStorage.getItem(key_local_storage_cart) ? JSON.parse(localStorage.getItem(key_local_storage_cart) ) : [],
            user: localStorage.getItem(key_local_storage_user) ? JSON.parse(localStorage.getItem(key_local_storage_user) ) : {},
            precio_producto_seleccionado: false,
            precio_producto_seleccionado_error: false,
            tipo_descuento_seleccionado: false,
            permitir_cambiar_precio_modal: true,
            loadingActualizandoProducto: false,
            showSearch: true,
            snack: {
              open: false,
              message: ""
            },
            loadingTrash: false,
            trashedIds: []
        }

        this.controller = null

        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleChangeSelectMarca = this.handleChangeSelectMarca.bind(this)
        this.handleChangeSelectModelo = this.handleChangeSelectModelo.bind(this)
        this.handleChangeSelectCilindrada = this.handleChangeSelectCilindrada.bind(this)
        this.handleChangeState = this.handleChangeState.bind(this)
        this.handleSubmitCodigo = this.handleSubmitCodigo.bind(this)
        this.handleChangeCantidad = this.handleChangeCantidad.bind(this)
        this.handleChangePrice = this.handleChangePrice.bind(this)
        this.handleChangeNotas = this.handleChangeNotas.bind(this)
        this.fetchDatos = debounce(this.fetchDatos.bind(this), 500);
    }

    validarCarrito(){
      const { carrito, user } = this.state
    //   if(user?.data?.propietario){
    //     const encontrar = carrito.filter(pro => pro.propietario && pro.propietario !== user?.data?.propietario )  
    //     if(encontrar.length > 0){
    //       toast.warning("Usuario diferente detectado, se limpió el carrito del navegador")
    //       localStorage.setItem(key_local_storage_cart, JSON.stringify([]))
    //       this.setState({ carrito: [] })
    //   }
    // }
    }

    verificarProductosTrash(){
      const { carrito } = this.state
      if(!carrito || carrito.length < 1) {
        return this.setState({ trashedIds: [] })
      }
      const ids = carrito.map(p => p._id).filter(Boolean)
      if(ids.length < 1) {
        return this.setState({ trashedIds: [] })
      }

      this.setState({ loadingTrash: true, trashedIds: [] })

      fetch(`${urlapi}/productos/check-trash`, {
          method: 'POST',
          body: JSON.stringify({ ids }),
          headers: { 'Content-Type': 'application/json' }
      })
      .then(res => res.json())
      .then(res => {
          if(res?.trashed && Array.isArray(res.trashed) && res.trashed.length > 0){
              const ids_trashed = res.trashed.map(p => p._id)
              this.setState({ loadingTrash: false, trashedIds: ids_trashed })
          } else {
              this.setState({ loadingTrash: false, trashedIds: [] })
          }
      })
      .catch(error => {
          console.error('Error verificando productos trash:', error.message)
          this.setState({ loadingTrash: false })
      })
    }

    async detallesSitio () {
      const loading = "loadingSite"
      this.setState({ [loading]: true })
      return fetch(`${urlapi}/sitios/details`,{
        method: "GET",
        headers: {
            'Content-Type': 'application/json',
        }
      })
      .then(res => res.json())
      .then(res => {
          if(!res){
          } else if(res.errorMessage){
          } else if(res._id){
            this.props.refrescarSitio(res)

            let title = res.titulo
            document.title = title;
          }
        return this.setState({ [loading]: false })
      })
      .catch(error => {
        return this.setState({ [loading]: false })
      })

    }

    async validateSite(){
      await this.detallesSitio()
      this.handleSubmit(null, null, 1)
    }

    componentDidMount(){
      this.validateSite()
      
      this.validarCarrito()
    }

    trackFacebookEvent(eventName, payload) {
      if (typeof window === "undefined") return
      if (typeof window.fbq !== "function") return
      window.fbq("track", eventName, payload)
    }
    
    onChangeCategoria(key){
      let cond = key === "todos" ? {} : { id_categoria: key }
      this.setState({ condicion: cond, pagina: 1 })
      this.handleSubmit(null, cond, 1, true)
    }

    getCilindrada(){
      const loading = 'loadingCilindrada'
      this.setState({ [loading]: true })
      const { propietario }  = this.state
      const url = `${urlapi}/productos/cilindradas`;
      this.setState({ [loading] : true })
      return fetch(url)
      .then(pros => pros.json())
      .then(pros => {
        if(!pros){
          toast.error("No hubo respuesta del servidor")
        } else if(pros.errorMessage){
          toast.error(pros.errorMessage)
        } else if(Array.isArray(pros) !== false){
          this.setState({ cilindradas: pros.map(m => ({ value: m._id, label: m.titulo })) })
        }
          this.setState({ [loading]: false })
      })
      .catch(error => {
          this.setState({ [loading]: false })
          return toast.error('No se pudo realizar esta operación')
      })
  }
    getModelos(){
      const loading = 'loadingModelos'
      this.setState({ [loading]: true })
      const url = `${urlapi}/productos/modelos`;
      this.setState({ [loading] : true })
      return fetch(url)
      .then(pros => pros.json())
      .then(pros => {
        if(!pros){
          toast.error("No hubo respuesta del servidor")
        } else if(pros.errorMessage){
          toast.error(pros.errorMessage)
        } else if(Array.isArray(pros) !== false){
          this.setState({ modelos: pros.map(m => ({ value: m._id, label: m.titulo })) })
        }
          this.setState({ [loading]: false })
      })
      .catch(error => {
          this.setState({ [loading]: false })
          return toast.error('No se pudo realizar esta operación')
      })
  }

    handleChangeNotas(e){
      const { name, value } = e.target
      const { repuesto_seleccionado } = this.state
      repuesto_seleccionado[name] = value
      return this.setState({ repuesto_seleccionado })
    }

    handleChangeState(e){
      const { name, value } = e.target
      this.fetchDatos(value, null, 1)
      return this.setState({ [name]: value, codigo_busqueda: "" })
    }
    
    handleChangeSelectMarca(e){
      console.log(e)
      return this.setState({ selec_marca: e._id })
    }
    
    handleChangeSelectModelo(e){
      return this.setState({ selec_modelo: e.value })
    }

    handleChangeSelectCilindrada(e){
      return this.setState({ selec_cilindrada: e.value })
    }
    
    misDatos(){
      return <Row className="bienvenida">

      
        <Col xs={12} className="mt-3"> <h5>Mis datos</h5>  </Col>

        <Col md={3}>
        <Card >
          <Card.Body>
            <p className="text-primary nomargin" >Estado del usuario</p>
            <p className="nomargin" style={{ fontSize: 12 }} >Activo</p>
          </Card.Body>
        </Card>
        </Col>
        <Col md={3}>
        <Card >
          <Card.Body>
            <p className="text-primary nomargin" >Email</p>
            <p className="nomargin" style={{ fontSize: 12 }} >Abdías Laguna</p>
          </Card.Body>
        </Card>
        </Col>

      </Row>

    }

    paginar(page,ignorar) {
      if(ignorar) return false
      this.setState({ pagina: page })
      this.handleSubmit(null, null, page)
    }

    paginacion(ciclo, total) {
      const { pagina } = this.state
      const cantidad = Math.ceil(total / ciclo)
      return <div>
          <Pagination size='sm'>
              {
                  Array.from(Array(cantidad).keys()).map(number => {
                      const active = pagina === (number+1) ? true : false
                      return <Pagination.Item key={number+1} active={active} onClick={()=> this.paginar(number+1,active)} >{number+1}</Pagination.Item>
                  })
              }
          </Pagination>
      </div>
  }
  

    async fetchDatos(word, condition, page) {
      const { pagina, condicion, user } = this.state
      // if (!word) return;

      // Cancela la solicitud anterior si existe
      if (this.controller) {
          this.controller.abort();
      }
      this.controller = new AbortController();
      const signal = this.controller.signal;

      try {
          
        const loading = "loadingResultados"
        const pagina_paginar = page ? page : pagina
        const cond = condition ? condition : condicion
        this.setState({ [loading]: true, resultados: [], total: 0 })
        return fetch(`${urlapi}/productos/sitio/search-v2`,{
          method: "POST",
          body: JSON.stringify({
            nombre: word,
            pagina: pagina_paginar,
            condicion: cond
          }),
          signal,
          headers: {
              'Content-Type': 'application/json',
          }
        })
        .then(res => res.json())
        .then(resultados => {
          if(!resultados){
            toast.error("Sin datos del servidor")
          } else if(resultados.errorMessage){
            toast.error(resultados.errorMessage)
          } else if( Array.isArray(resultados.datos) ){
            this.setState({ resultados: resultados.datos, total: resultados.total })
            this.sincronizarStockCarrito(resultados.datos)
        }
          return this.setState({ [loading]: false })
        })
        .catch(error => {
          console.log(error)
          return this.setState({ [loading]: false })
        })
  
        
      } catch (error) {
          if (error.name !== "AbortError") {
              console.error("Error en la búsqueda:", error);
          }
      } finally {

      }
  }

    fetchCodigo(codigo_busqueda){
      const { user } = this.state
      if(!codigo_busqueda) return toast.error("Debes introducir el código de búsqueda")
      const loading = "loadingResultados"
      this.setState({ [loading]: true })
      return fetch(`${urlapi}/productos/search-code-v2`,{
        method: "POST",
        body: JSON.stringify({
          codigo_busqueda: codigo_busqueda.toUpperCase()
        }),
        headers: {
            'Content-Type': 'application/json',
        }
      })
      .then(res => res.json())
      .then(resultados => {
        if(!resultados){
          toast.error("Sin datos del servidor")
        } else if(resultados.errorMessage){
          toast.error(resultados.errorMessage)
        } else if(Array.isArray(resultados) !== false){
          this.setState({ resultados })
          this.sincronizarStockCarrito(resultados)
      }
        return this.setState({ [loading]: false })
      })
      .catch(error => {
        console.log(error)
        return this.setState({ [loading]: false })
      })
    }

    stroolToDiv(){
      const doc = document.getElementById("table-products")
      if(!doc) return false
      const top = doc.offsetTop
      const scrollTo = top - 100
      window.scrollTo({
        top: scrollTo,
        behavior: 'smooth'
      });
    }

    handleSubmit(e, condition, page, scrollToProducts){
      const { pagina, selec_palabra, condicion, user } = this.state
      if(e) e.preventDefault()
      const loading = "loadingResultados"
      const pagina_paginar = page ? page : pagina
      const cond = condition ? condition : condicion
      this.setState({ [loading]: true })
      if(scrollToProducts) this.stroolToDiv()
      return fetch(`${urlapi}/productos/sitio/search-v2`,{
        method: "POST",
        body: JSON.stringify({
          nombre: selec_palabra,
          pagina: pagina_paginar,
          condicion: cond
        }),
        headers: {
            'Content-Type': 'application/json',
        }
      })
      .then(res => res.json())
      .then(resultados => {
          
        if(!resultados){
          toast.error("Sin datos del servidor")
        } else if(resultados.errorMessage){
          toast.error(resultados.errorMessage)
        } else if(Array.isArray(resultados.datos) !== false){
//          setTrabajadores(res.datos)
  //        setTotal(res.total)
          this.setState({ resultados: resultados.datos, total: resultados.total })
          this.sincronizarStockCarrito(resultados.datos)
      }
        return this.setState({ [loading]: false })
      })
      .catch(error => {
        console.log(error)
        return this.setState({ [loading]: false })
      })
    }

    removeQueryParam = (key) => {
      const { location, navigate } = this.props;
      const params = new URLSearchParams(location.search);
      params.delete(key);
      navigate({ pathname: location.pathname, search: params.toString() }, { replace: true });
    };
  

    handleClose(){
      this.removeQueryParam("product")
      return this.setState({ repuesto_seleccionado: false, permitir_cambiar_precio_modal: true, precio_producto_seleccionado: false, tipo_descuento_seleccionado: false })
  }

    mostrarSnack(message){
      if(!message) return
      const snack = { open: true, message }
      this.setState({ snack })
    }

    cerrarSnack(){
      this.setState({ snack: { open: false, message: "" } })
    }

    seleccionarRepuesto(repuesto_seleccionado) {
      const instancia_producto = JSON.parse( JSON.stringify(repuesto_seleccionado) )
      instancia_producto.cantidad = 1
      instancia_producto.precio_original = instancia_producto.precio
      this.setState({ repuesto_seleccionado: instancia_producto, precio_producto_seleccionado: instancia_producto.precio })
      const unitPrice = Number(instancia_producto?.precio) || 0
      this.trackFacebookEvent("ViewContent", {
        content_ids: [instancia_producto?._id],
        content_name: instancia_producto?.titulo,
        content_type: "product",
        currency: "CLP",
        value: unitPrice
      })
      const valor_string = formatoMoneda(instancia_producto.precio).toString()
      setTimeout(() => {
        if(document.getElementById('numero_precio')) document.getElementById('numero_precio').value = valor_string
      }, 100);
    }

    onChangeCarrito(new_cart){
        localStorage.setItem(key_local_storage_cart, JSON.stringify(new_cart))
        this.setState({ carrito: new_cart }, () => {
            this.verificarProductosTrash()
        })
    }

    removerDeCarrito(i){
      const { carrito } = this.state
      carrito.splice(i,1)
      this.onChangeCarrito(carrito)
    }

    onMinus(pos){
      const { resultados, carrito, tipo_descuento_seleccionado } = this.state
      const repuesto_seleccionado = resultados[pos]
      const i = carrito.findIndex(p => p._id === repuesto_seleccionado._id)
      if(i < 0) return false
      let valor = Math.max(1, parseInt(carrito[i].cantidad) - 1)
      
      carrito[i].cantidad = valor
      return this.onChangeCarrito(carrito)
    }

    onAdd(pos){
      
      const { resultados, carrito, tipo_descuento_seleccionado } = this.state
      const repuesto_seleccionado = resultados[pos]

      const i = carrito.findIndex(p => p._id === repuesto_seleccionado._id)
      let cantidad_modal_producto = parseInt(repuesto_seleccionado.cantidad)
      const stockDisponible = this.obtenerStockDisponible(repuesto_seleccionado)

      if(stockDisponible === 0){
        toast.info("No hay inventario disponible para este producto")
        return
      }

      let addedQuantity = 0
      if(i > -1){
        const cantidadActual = parseInt(carrito[i].cantidad) || 0
        let total_nuevo = cantidadActual + 1
        if(stockDisponible !== false && total_nuevo > stockDisponible){
          total_nuevo = stockDisponible
          this.mostrarSnack(`Solo hay ${stockDisponible} unidades disponibles`)
        }

        carrito[i].cantidad = total_nuevo
        addedQuantity = total_nuevo - cantidadActual
      } else {
        if(!cantidad_modal_producto) cantidad_modal_producto = 1
        if(stockDisponible !== false && cantidad_modal_producto > stockDisponible){
          cantidad_modal_producto = stockDisponible
          this.mostrarSnack(`Solo hay ${stockDisponible} unidades disponibles`)
        }
        if(tipo_descuento_seleccionado) repuesto_seleccionado.descuentos = [ tipo_descuento_seleccionado ]
        repuesto_seleccionado.cantidad = cantidad_modal_producto
        carrito.push(repuesto_seleccionado)
        addedQuantity = cantidad_modal_producto
      }
      this.onChangeCarrito(carrito)
      this.setState({ repuesto_seleccionado: false })
      if(addedQuantity > 0){
        const unitPrice = Number(repuesto_seleccionado?.precio) || 0
        this.trackFacebookEvent("AddToCart", {
          content_ids: [repuesto_seleccionado?._id],
          content_name: repuesto_seleccionado?.titulo,
          content_type: "product",
          currency: "CLP",
          value: unitPrice * addedQuantity,
          num_items: addedQuantity
        })
      }
    }

    agregarCarrito(pro){
      const { repuesto_seleccionado, carrito, precio_producto_seleccionado_error, tipo_descuento_seleccionado } = this.state
      if(precio_producto_seleccionado_error === true ) return toast.error("Error en el precio")
      
      const producto_ = pro ? pro : repuesto_seleccionado
      const i = carrito.findIndex(p => p._id === producto_._id)
      const stockDisponible = this.obtenerStockDisponible(producto_)
      let seAlcanzaLimiteStock = false
      const avisarLimiteStock = () => {
        if(!seAlcanzaLimiteStock && stockDisponible !== false){
          seAlcanzaLimiteStock = true
        this.mostrarSnack(`Solo hay ${stockDisponible} unidades disponibles`)
      }
      }

      if(stockDisponible === 0){
        toast.info("No hay inventario disponible para este producto")
        return
      }

      let cantidad_modal_producto = parseInt(producto_.cantidad)
      let addedQuantity = 0
      if(i > -1){
        let cantidad = cantidad_modal_producto ? cantidad_modal_producto : 1
        if(stockDisponible !== false && cantidad > stockDisponible){
          cantidad = stockDisponible
          avisarLimiteStock()
        }
        const cantidadActual = parseInt(carrito[i].cantidad) || 0
        let total_nuevo = cantidadActual + cantidad
        if(stockDisponible !== false && total_nuevo > stockDisponible){
          total_nuevo = stockDisponible
          avisarLimiteStock()
        }

        carrito[i].cantidad = total_nuevo
        addedQuantity = total_nuevo - cantidadActual
      } else {
        if(!cantidad_modal_producto) cantidad_modal_producto = 1
        if(stockDisponible !== false && cantidad_modal_producto > stockDisponible){
          cantidad_modal_producto = stockDisponible
          avisarLimiteStock()
        }
        if(tipo_descuento_seleccionado) producto_.descuentos = [ tipo_descuento_seleccionado ]
        producto_.cantidad = cantidad_modal_producto
        carrito.push(producto_)
        addedQuantity = cantidad_modal_producto
      }
      this.onChangeCarrito(carrito)
      this.setState({ repuesto_seleccionado: false })
      if(!seAlcanzaLimiteStock) toast.success("Producto agregado al carrito")
      if(addedQuantity > 0){
        const unitPrice = Number(producto_?.precio) || 0
        this.trackFacebookEvent("AddToCart", {
          content_ids: [producto_?._id],
          content_name: producto_?.titulo,
          content_type: "product",
          currency: "CLP",
          value: unitPrice * addedQuantity,
          num_items: addedQuantity
        })
      }
    }

    handleChangeCantidad(e) {
      const { value } = e.target
      const { repuesto_seleccionado } = this.state
      let cantidad = parseInt(value)
      if(isNaN(cantidad) || cantidad < 1) cantidad = 1
      const stockDisponible = this.obtenerStockDisponible(repuesto_seleccionado)
      if(stockDisponible !== false && cantidad > stockDisponible){
        cantidad = stockDisponible
        this.mostrarSnack(`Solo hay ${stockDisponible} unidades disponibles`)
      }
      repuesto_seleccionado.cantidad = cantidad
      return this.setState({ repuesto_seleccionado })
    }

    obtenerMaximoPrecio() {
      const { user } = this.state
      if(!user) return false
      if(!user.data) return false
      if(typeof user.data !== "object") return false
      if(typeof user.data.allow_rise_price_percentage === "undefined" || user.data.allow_rise_price_percentage === null) return false
      return user.data.allow_rise_price_percentage
    }

    obtenerMinimoPrecio() {
      const { user } = this.state
      if(!user) return false
      if(!user.data) return false
      if(typeof user.data !== "object") return false
      if(typeof user.data.allow_down_price_percentage === "undefined" || user.data.allow_down_price_percentage === null) return false
      return user.data.allow_down_price_percentage
    }

    obtenerStockDisponible(producto) {
      if(!producto) return false
      const stock = parseInt(producto.totalStock)
      if(isNaN(stock)) return false
      return Math.max(0, stock)
    }

    sincronizarStockCarrito(productos){
      const { carrito } = this.state
      if(!Array.isArray(productos) || carrito.length < 1) return
      let actualizado = false
      const carritoActualizado = carrito.map(item => {
        const encontrado = productos.find(p => p._id === item._id)
        if(encontrado){
          let nuevoItem = { ...item }
          let itemActualizado = false;

          const stockDisponible = this.obtenerStockDisponible(encontrado)
          if(stockDisponible !== false && item.totalStock !== stockDisponible){
            itemActualizado = true
            nuevoItem.totalStock = stockDisponible
          } else if(stockDisponible === false && typeof item.totalStock !== "undefined"){
            itemActualizado = true
            delete nuevoItem.totalStock
          }

          if(encontrado.precio !== item.precio) {
            itemActualizado = true
            nuevoItem.precio = encontrado.precio
          }

          if(encontrado.original_price !== item.original_price) {
            itemActualizado = true
            if(encontrado.original_price) {
              nuevoItem.original_price = encontrado.original_price
            } else {
              delete nuevoItem.original_price
            }
          }

          if (itemActualizado) {
            actualizado = true
            return nuevoItem
          }
        }
        return item
      })
      if(actualizado){
        this.onChangeCarrito(carritoActualizado)
      }
    }

    obtenerMaximoMinimo(){
      const { precio_producto_seleccionado } = this.state
      if(!precio_producto_seleccionado) return false

      const anterior = precio_producto_seleccionado
      const maximo = this.obtenerMaximoPrecio()
      let monto_maximo = 0
      const minimo = this.obtenerMinimoPrecio()
      let monto_minimo = 0
      let precio_producto_seleccionado_error = false

      if(maximo !== false) monto_maximo = anterior + ((anterior*maximo)/100)
      if(minimo !== false) monto_minimo = anterior - ((anterior*minimo)/100)
      return {
        monto_maximo,
        monto_minimo
      }
    }
    
    handleChangePrice(e) {
      const { value } = e.target
      const { repuesto_seleccionado, precio_producto_seleccionado } = this.state
      
      const input = value ? value.replace(/[.,;]/g, "") : ''
      let monto = parseInt(input) 
      if(isNaN(monto)) monto = 0

      const anterior = precio_producto_seleccionado
      const maximo = this.obtenerMaximoPrecio()
      let monto_maximo = 0
      const minimo = this.obtenerMinimoPrecio()
      let monto_minimo = 0
      let precio_producto_seleccionado_error = false

      if(maximo !== false) monto_maximo = anterior + ((anterior*maximo)/100)
      if(minimo !== false) monto_minimo = anterior - ((anterior*minimo)/100)
      
      if(minimo !== false){
        if(monto < monto_minimo){
          if(!precio_producto_seleccionado_error) precio_producto_seleccionado_error = true
        }
      }
      
      if(maximo !== false){
        if(monto > monto_maximo){
          if(!precio_producto_seleccionado_error) precio_producto_seleccionado_error = true
        }
      }

      repuesto_seleccionado.precio = monto
      const valor_string = formatoMoneda(monto).toString()
      if(document.getElementById('numero_precio')) document.getElementById('numero_precio').value = valor_string
      return this.setState({ repuesto_seleccionado, precio_producto_seleccionado_error })
    }

    removerDescuento(){
      const { repuesto_seleccionado, precio_producto_seleccionado } = this.state
      repuesto_seleccionado.precio = precio_producto_seleccionado
      this.setState({ tipo_descuento_seleccionado: false, repuesto_seleccionado, permitir_cambiar_precio_modal: true })
    }

    mostrarTipoDescuento(){
      const { tipo_descuento_seleccionado, user } = this.state

      const montos = this.obtenerMaximoMinimo()

      if(tipo_descuento_seleccionado !== false){
        if(tipo_descuento_seleccionado._id){
          return <div>
            <Card className='p-3 mb-3 shadow'>
            <h6 className='mb-0'>Seleccionaste el tipo de descuento temporal</h6>
            <Row className='mb-3'>
              <Col md={3}>
                <label className='form-control-label d-block'>Tipo</label>
                <h6 className='mb-0'>{tipo_descuento_seleccionado.tipo}</h6>
              </Col>
              <Col md={3}>
                <label className='form-control-label d-block'>Valor</label>
                <h6 className='mb-0'>{formatoMoneda(tipo_descuento_seleccionado.valor)}</h6>
              </Col>
              <Col md={6}>
                <label className='form-control-label d-block'>Concepto</label>
                <h6 className='mb-0'>{tipo_descuento_seleccionado.concepto}</h6>
              </Col>
            </Row>
            <Button size='sm' variant="outline-danger" onClick={() => this.removerDescuento()} ><i class="fas fa-trash"></i> REMOVER</Button>
            </Card>
          </div>
        } else {

        }
      }

      return <Card className='p-3 mb-2 shadow'>
      {
        montos ? <div>
          <h6 className='mb-0'>DESCUENTO AUTORIZADO</h6>
          <p className='mb-0'>Precio mínimo <b>{formatoMoneda(montos.monto_minimo)}</b></p>
          <p className='mb-0'>Precio máximo <b>{formatoMoneda(montos.monto_maximo)}</b></p>
          <hr className='mb-2 mt-2'/>
        </div> : false
      }
      <h6 className='mb-0'>DESCUENTOS TEMPORALES</h6>
      {/* <AplicarDescuento token={user.tokenSession} onSelectDescuento={(tipo_descuento_seleccionado) => {
        const { repuesto_seleccionado, precio_producto_seleccionado } = this.state
        let precio = precio_producto_seleccionado
        if(tipo_descuento_seleccionado.tipo === "porcentaje"){
            precio = precio_producto_seleccionado - Math.round(precio_producto_seleccionado * tipo_descuento_seleccionado.valor / 100)
        } else if(tipo_descuento_seleccionado.tipo === "monto_fijo"){
            precio = Math.min( precio_producto_seleccionado, Math.round( precio_producto_seleccionado - tipo_descuento_seleccionado.valor ) )
        }
        repuesto_seleccionado.precio = precio
        return this.setState({ tipo_descuento_seleccionado, permitir_cambiar_precio_modal: false })
      }} condicion_default={{ id_usuario_autorizado: user.data._id, status: "unredeemed" }} /> */}
      </Card>
    }

    mostrarPrecio(precio ){
      const { user, repuesto_seleccionado, permitir_cambiar_precio_modal } = this.state
      
      const showPriceStatic = (price) => <div className='mb-3'>
        <h2 className='mb-0'>{price.toLocaleString("es-CL", { style: "currency", currency: "CLP" })} {repuesto_seleccionado.original_price ? <b style={{ textDecoration: "line-through", fontWeight: "lighter", color: "gray", fontSize: 16,  }}>{formatoMoneda(repuesto_seleccionado.original_price)}</b> : false }</h2>
        {repuesto_seleccionado.original_price ? <Chip sx={{ fontSize: 14 }} size="small" label="Oferta" className="gradient-animated" /> : false }
        </div>
      if(!user) return showPriceStatic(precio)
      if(!user.data) return showPriceStatic(precio)
      if(typeof user.data !== "object") return showPriceStatic(precio)
      if(user.data.allow_change_price_product !== true) return showPriceStatic(precio)

      return <div className='mb-3'>
        <h2 className='mb-0'>${formatoMoneda(precio)} {repuesto_seleccionado.original_price ? <b style={{ textDecoration: "line-through", fontWeight: "lighter", color: "gray", fontSize: 16,  }}>{formatoMoneda(repuesto_seleccionado.original_price)}</b> : false }</h2>
        {repuesto_seleccionado.original_price ? <Chip sx={{ fontSize: 14 }} size="small" label="Oferta" className="gradient-animated" /> : false }
      </div>
    }

    mostrarInventarioProducto(producto){
      const stockDisponible = this.obtenerStockDisponible(producto)
      if(stockDisponible === false) return false
      return <p className='mb-2 text-muted'>Stock disponible: <b>{stockDisponible}</b></p>
    }

    async actualizarProducto() {
      const { repuesto_seleccionado, user } = this.state
      const loading = 'loadingActualizandoProducto'
      this.setState({ [loading]: true })
      return fetch(`${urlapi}/productos`,{
          method:'PUT',
          body: JSON.stringify({
            _id: repuesto_seleccionado._id,
            titulo: repuesto_seleccionado.titulo,
            notas: repuesto_seleccionado.notas
          }),
          headers: {
              'Content-Type':'application/json',
          }
      })
      .then(res => {
          
          return res.json()
      })
      .then(res => {
          if(!res){
              toast.error('Sin datos')
          } else if(res.errorMessage){
              toast.error(res.errorMessage)
          } else if(res._id){
              toast.success('Guardado exitosamente')
          }
          return this.setState({ [loading]: false })
      })
      .catch(error => {
          toast.error(error.message)
          return this.setState({ [loading]: false })
      })
  }


    showDescription(){
      const { repuesto_seleccionado } = this.state
      if(!repuesto_seleccionado) return false

      const fields = repuesto_seleccionado.fields || []
      return <div>
        <Row>
        {
          fields.map((field, i) => {
            if(field?.value.toString() === "-") return 
            return <Col xs={!field.image ? 12 : 4} lg={!field.image ? 12 : 3} key={`-${i}`} className='mb-3'>
              {
                field.image ? <div>
                  <img alt={field.title} style={{ width: "60%" }} src={field.image} />
                  <p style={{ fontSize: 12 }} className='mb-0'>{field.title}</p>
                </div> : <div>
                  <h6 className='mb-0'>{field.title}</h6>
                  <p style={{ fontSize: 12 }} className='mb-0'>{field.value}</p>
                </div>
              }
            </Col>
          })
        }
        </Row>
      </div>
    }

    modalRepuestoSeleccionado(){
      const { repuesto_seleccionado, modelos, loadingActualizandoProducto, cilindradas, precio_producto_seleccionado_error } = this.state
      if(!repuesto_seleccionado) return false
      const stockDisponible = this.obtenerStockDisponible(repuesto_seleccionado)
      const sinStock = stockDisponible !== false && stockDisponible < 1
      const cantidadSeleccionada = parseInt(repuesto_seleccionado.cantidad)
      const limiteAlcanzado = stockDisponible !== false && !isNaN(cantidadSeleccionada) && cantidadSeleccionada > stockDisponible

      return <Dialog maxWidth='md' scroll="body" fullWidth open={repuesto_seleccionado ? true : false} onClose={()=>this.handleClose()} centered >
        <div className='p-3'>
        <Row>
          <Col xs={10}><h3>{capitalizeFirstLetter(repuesto_seleccionado.titulo)}</h3></Col>
          <Col xs={2} className='text-right'><IoCloseSharp className='hover' onClick={() => this.handleClose()} size={30} /></Col>
        </Row>
        <Row>
          <Col md={12}>
          <Row className='mb-2'>
            <Col md={5} xs={12}>
            { repuesto_seleccionado.img ? <img alt={repuesto_seleccionado.titulo} style={{ width: "100%" }} src={repuesto_seleccionado.img} /> : false }
            </Col>
            <Col md={7} xs={12}>
            <Badge variant='dark' style={{ textTransform: "uppercase" }}>SKU {repuesto_seleccionado.codigo}</Badge>
            {/* <Inventario id={repuesto_seleccionado._id} /> */}
            {this.mostrarPrecio(repuesto_seleccionado.precio)}
            {this.mostrarInventarioProducto(repuesto_seleccionado)}
            {this.showDescription()}
            <Row>
              <Col xs={4}>
                <label className='form-control-label d-block'>Cantidad</label>
                <input className='form-control' type="number" value={repuesto_seleccionado.cantidad} onChange={this.handleChangeCantidad} />
              </Col>
              <Col xs={8}>              
                <label className='form-control-label d-block'>Click para agregar</label>
                { precio_producto_seleccionado_error ? (
                  <Button variant='secondary' className='mb-2 w-100'><i className="text-danger fas fa-exclamation-triangle"></i> PRECIO NO AUTORIZADO</Button>
                ) : (
                  <Tooltip title={ (sinStock || limiteAlcanzado) ? "Sin stock" : "" }>
                    <span className='d-block'>
                      <Button
                        variant='success'
                        className='mb-2 w-100'
                        onClick={() => this.agregarCarrito()}
                        disabled={sinStock || limiteAlcanzado}
                      >
                        AGREGAR AL CARRITO
                      </Button>
                    </span>
                  </Tooltip>
                ) }
              </Col>
            </Row>
              
            </Col>
          </Row>
          </Col>
        </Row>
        </div>
    </Dialog>
  }

    tablaRegistros(registros){

      const { loadingResultados, user } = this.state
      if(loadingResultados) return this.cargando()
      if(registros.length < 1) return <div className='p-5'>
        <Row className="justify-content-md-center">
                    <Col md={8} className="text-center">
                      <img src={`${url_images}/animations/Man shopping online.gif`} style={{ width: "30%" }} />
                      <h3>Busca un producto</h3>
                      <Button size="sm" onClick={() => this.handleSubmit(null, null, 1)}>ACTUALIZAR</Button>
                      {/* <p>Busca los productos en la parte superior para comenzar a agregar al carrito</p> */}
                    </Col>
                    </Row>
      </div>
        return <div>
          <Row>
          {
          registros.map((res,ir) => {
            return <Col md={4} className='hover' key={`res${res.titulo}-${res.codigo_proveedor}`}>
              <BoxListProduct 
                product={res} 
                onSelect={(data) => this.seleccionarRepuesto(data)} 
                onProductRemoved={(pos) => this.removeProduct(ir)}
                onAdd={(data) => this.onAdd(ir)}
                addToCart={() => this.agregarCarrito(res)}
                onMinus={() => this.onMinus(ir)}
              />
            </Col>
          })
        }
          </Row>
        </div>
    }

    cargando(){
      const size = 100
      const col = 3
      const cantidad = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]
      return <div className='mt-4'>
        <Row>
          {cantidad.map((e,i) => <Col key={`col-${i}`} md={col} className="mb-3"><Skeleton height={size} /></Col>)}
        </Row>
      </div>
    }

    ordenamiento() {
      return
      return <div className='mb-3'>
       <Dropdown className='p-0 mr-2'  style={{ display: "inline-block" }}>
        <Dropdown.Toggle variant='light' size="sm" id="dropdown-basic">ORDENAR POR <FaAngleDown size={18} style={{ verticalAlign: "initial" }} /></Dropdown.Toggle>
        <Dropdown.Menu>
        <Dropdown.Item >MENOR PRECIO</Dropdown.Item>
        <Dropdown.Item >MAYOR PRECIO</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      <Button size='sm' variant='light'>OFERTAS <IoIosStar style={{ verticalAlign: "initial" }} /></Button>
      </div>
    }

    mostrarResultados(){
      const { loadingResultados, resultados, total } = this.state
      if(loadingResultados) return this.cargando()
      if(resultados.length < 1) return <div className='p-5'>
        <Row className="justify-content-md-center">
                    <Col md={8} className="text-center">
                      <img src={`${url_images}/animations/Man shopping online.gif`} style={{ width: "30%" }} />
                      <h3>Sin resultados</h3>
                      <Button size="sm" onClick={() => this.handleSubmit(null, null, 1)}>ACTUALIZAR</Button>
                      {/* <p>Busca los productos en la parte superior para comenzar a agregar al carrito</p> */}
                    </Col>
                    </Row>
      </div>


      return <div >
        <hr />
        <h5>Productos</h5>
        {this.ordenamiento()}
        {this.tablaRegistros(resultados)}
        {this.paginacion(100, total)}
      </div>
    }

    removeProduct(pos){
      const { resultados, carrito } = this.state
      const producto = resultados[pos]
      const i = carrito.findIndex(p => p._id === producto._id)
      if(i > -1) this.onProductRemoved(i)
    }

    onProductRemoved(pos){
      const { carrito } = this.state
      carrito.splice(pos, 1)
      this.onChangeCarrito(carrito)
      return false
    }

    cleanCart(pos){
      this.onChangeCarrito([])
      return false
    }

    handleSubmitCodigo(e) {
      e.preventDefault()
      const { codigo_busqueda } = this.state
      return this.fetchCodigo(codigo_busqueda)
    }

    onResultados(data){
      return this.setState({ resultados: data })
    }
    
    onSelectProduct(data){
      return this.setState({ resultados: [data] })
    }

    showSearch(){
      return <form onSubmit={(e) => e.preventDefault()}>
      <input placeholder='BUSCAR POR PALABRA CLAVE' className='form-control' name="selec_palabra" onChange={this.handleChangeState} />
    </form>
    }

    buscadorAvanzado() {
      const { carrito, category } = this.state
      const medium_1 = <Banners zone="home_medium_1" />
      const medium_2 = <Banners zone="home_medium_2" />
      const isMobile = window.innerWidth < 768

      return <div className='pr-4 pl-4 pb-4'>
        <UseCart cart={carrito} />
        {
          medium_1 || medium_2 ? <Row>
            {medium_1 ? <Col md={6} xs={12}><div className='mb-3'>{medium_1}</div></Col> : false}
            {medium_2 ? <Col md={6} xs={12}><div className='mb-3'>{medium_2}</div></Col> : false}
          </Row> : false
        }
            <div><CategoriasSelector default_category={category} onSelect={(key) => this.onChangeCategoria(key)} /></div>
            <div id="table-products">
            {this.mostrarResultados()}
            </div>
            </div>
    }

    cambiarInterfazProductos(products_view) {
      const actual = JSON.parse( JSON.stringify(this.props.interfaz) )
      actual.products_view = products_view
      this.props.guardarInterfaz(actual)
    }

    mostrarCarritoPequeno(){
      const { showModalCarrito, carrito } = this.state
      const isMobile = window.innerWidth < 768

      const styleBadge = isMobile ? { position: "relative", bottom: 32, left: 33, fontSize: 10 } : { position: "absolute", bottom: 32, right: 33, fontSize: 10 }
      const cart = <Carrito carrito={carrito} 
      onProductRemoved={(pos) => this.onProductRemoved(pos)} 
      onChangeCarrito={(new_cart) => this.onChangeCarrito(new_cart)} 
      cleanCart={() => this.cleanCart()}
      onReplaceCart={(new_cart) => this.setState({ carrito: new_cart })}
      loadingTrash={this.state.loadingTrash}
      trashedIds={this.state.trashedIds}
    />

      return <div style={{ display: isMobile ? "" :"table" }} >
         <div className='hover' style={{ display: isMobile ? "" : "table-cell", verticalAlign: "middle" }} onClick={() => { this.setState({ showModalCarrito: true }); this.verificarProductosTrash(); }}>
          <FaCartShopping style={{ display: "inline-block" }} color="black" size={25} />
          {carrito.length > 0 ? <span className='badge badge-danger ml-2 mr-2' style={{}}>{carrito.length}</span> : false}
         </div>
        <Drawer open={showModalCarrito} onClose={() => this.setState({ showModalCarrito: false })} centered >
          <div className='p-2 text-right'><IoClose size={30} onClick={() => this.setState({ showModalCarrito: false })} /> </div>
          <div className='p-3'>{cart}</div>
        </Drawer>
      </div>
    }

    mostrarCarrito(){
      const { showModalCarrito, carrito } = this.state
      const isMobile = window.innerWidth < 768

      const cart = <Carrito carrito={carrito} 
      onProductRemoved={(pos) => this.onProductRemoved(pos)} 
      onChangeCarrito={(new_cart) => this.onChangeCarrito(new_cart)} 
      cleanCart={() => this.cleanCart()}  
      onReplaceCart={(new_cart) => this.setState({ carrito: new_cart })}
      loadingTrash={this.state.loadingTrash}
      trashedIds={this.state.trashedIds}
    />


      if(!isMobile) return cart
      if(isMobile) return <div>
        { !showModalCarrito ? <div className='hover' style={{ padding: 15, position: "fixed", bottom: 10, right: 10, zIndex: 9999, borderRadius: "50%", background: "black" }} onClick={() => { this.setState({ showModalCarrito: true }); this.verificarProductosTrash(); }}><FaCartShopping color="white" size={30} /></div> : false}
        <Drawer open={showModalCarrito} onClose={() => this.setState({ showModalCarrito: false })} size='lg' centered >
          <div className='p-2 text-right'><IoClose size={30} onClick={() => this.setState({ showModalCarrito: false })} /> </div>
          <div className='p-3'>{cart}</div>
        </Drawer>
      </div>
    }

    mostrarFooter(){
      const newsletter = <NewletterSite />
      const social = <SocialIcons zone="social_media_footer" />
      const footer_text = <FooterText />
      if(!newsletter && !social && !footer_text) return false

      return <footer>
          <div className='p-4 bg-white'>
            <Row className='justify-content-md-center'>
            {newsletter ? <Col md={8} xs={12}>{newsletter}</Col> : false }
            {social ? <Col md={3} xs={12}>{social}</Col> : false }
            </Row>
            {footer_text ? <div className='mt-3'>{footer_text}</div> : false }
        </div>
      </footer>
    }

    buscadorCodigo(){
      const isMobile = window.innerWidth < 768

      return <div className='pr-2 pl-2'>
        <BuscadorProductoPublico typeView="big" tipo="funcion" onSelectProduct={(data) => this.seleccionarRepuesto(data)} showResults={true} cond={{}} />
      </div>
    }

    render(){
      const { carrito, loadingSite } = this.state
      if(loadingSite) return <Row className="justify-content-md-center">
          <Col md={8} className="text-center">
          <Spinner animation="border" />
          </Col>
      </Row>


        return <div>
            <Header onSelectCategory={(e) => this.setState({ category: e })} fetchFunction={this.handleSubmit} searchBox={this.buscadorCodigo()} cart={this.mostrarCarritoPequeno()} />
            {/* <CategoriasSelector typeView="topbar" /> */}
            <MessageTop />
            <div className=''><Banners zone="home_top" /></div>
                          {this.buscadorAvanzado()}
                          {this.modalRepuestoSeleccionado()}
                          <Snackbar open={this.state.snack.open} autoHideDuration={3000} onClose={() => this.cerrarSnack()} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                            <Alert
                              onClose={() => this.cerrarSnack()}
                              severity="info"
                              variant="filled"
                              sx={{ width: '100%', background: "#000", color: "#fff" }}
                            >
                              {this.state.snack.message}
                            </Alert>
                          </Snackbar>
            {this.mostrarFooter()}

      </div>
    }
}

const mapStateToProps = (state) => {
    return {
        miusuario: state.miusuario,
        interfaz: state.interfaz,
        bodegas: state.bodegas,
        sitio: state.sitio
    }
}

const mapDispatchToProps = (dispatch) => {
  return {
      guardarInterfaz: (data) => dispatch(guardarInterfaz(data)),
      logout: () => dispatch(cerrarSesion()),
      refrescarSitio: (res) => dispatch(refrescarTienda(res))
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(withRouterV6(Home));
